import { render, staticRenderFns } from "./DocumentSelectorListStyle.vue?vue&type=template&id=099809fc&scoped=true&"
import script from "./DocumentSelectorListStyle.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelectorListStyle.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSelectorListStyle.vue?vue&type=style&index=0&id=099809fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099809fc",
  null
  
)

export default component.exports